import {ReactNode} from 'react';

interface Props {
  id: string;
  title: ReactNode;
  description?: ReactNode;
  titleSuffix?: ReactNode;
  children: ReactNode;
  actions?: ReactNode;
}
export function AccountSettingsPanel({
  id,
  title,
  description,
  titleSuffix,
  children,
  actions,
}: Props) {
  return (
    <section id={id} className="acctPanel">
      <div className="acctPanel__header">
        <div className="acctPanel__header-left">
          <div className="acctPanel__title">{title}</div>
          {description && (
            <div className="acctPanel__description">{description}</div>
          )}
        </div>
        {titleSuffix && <div className="flex-shrink-0">{titleSuffix}</div>}
      </div>
      <div className="acctPanel__body">{children}</div>
      {actions && (
        <div className="acctPanel__actions">{actions}</div>
      )}
    </section>
  );
}
